import styled from 'styled-components';
import DefaultContentLoader from 'react-content-loader';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  padding: 2.4375rem 2rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1rem;
`;

// TODO: TFR-45:ContentLoader make unique name or do not export
export const ContentLoader = styled(DefaultContentLoader)`
  width: 100%;
`;
